module.exports = __webpack_public_path__ + "static/media/0003_Medium.8bb72175.jpg";